export default __webpack_public_path__ + "static/media/apple-store.99490fbe.svg";